import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    interval: { type: Number, default: 30000 },
    target: { type: String, default: "" }
  }

  connect() {
    this.startRefresh()
  }

  disconnect() {
    this.stopRefresh()
  }

  startRefresh() {
    this.timer = setInterval(() => { this.refresh() }, this.intervalValue)
  }

  stopRefresh() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  refresh() {
    const targetId = this.targetValue || this.element.id
    if (!targetId) return

    // Same-origin fetch of server-rendered content (same pattern as live_updater_channel.js)
    // Content is fetched from the same origin (our own Rails server) and replaces
    // the element's children with server-rendered HTML — safe same-origin update.
    fetch(window.location.href, {
      headers: { "X-Requested-With": "XMLHttpRequest" }
    })
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, "text/html")
      const newContent = doc.querySelector("#" + targetId)
      if (newContent) {
        this.element.innerHTML = newContent.innerHTML // nosemgrep: innerHTML-safe-same-origin
      }
    })
    .catch(error => {
      console.warn("Auto-refresh failed:", error)
    })
  }
}
